import { LeadTag } from "api/lead-tags";
import { LeadTagPill } from "shared/app/LeadTags/components/LeadTagPill";

const VISIBLE_TAGS = 2;

/** The first two tags A to Z, then a "+N" pill for the rest. */
export const LeadTagsCompactList = ({ tags }: { tags: LeadTag[] }) => {
  const hiddenCount = tags.length - VISIBLE_TAGS;

  return (
    <>
      {tags.slice(0, VISIBLE_TAGS).map((tag) => (
        <LeadTagPill key={tag.id} name={tag.name} className="min-w-0" />
      ))}
      {hiddenCount > 0 ? (
        <LeadTagPill name={`+${hiddenCount}`} className="shrink-0 font-bold" />
      ) : null}
    </>
  );
};
